/* eslint-disable @typescript-eslint/no-explicit-any */
import { calculateTotalHours } from '../helpers/calculateTotalHours';
import { filterUniqueProjects } from '../helpers/filterUniqueProjects';
import { groupByProjects } from '../helpers/groupByProjects';
import { decimalToTime } from '../../../utils/date-formatting';

import { ClientProjectHours } from '../types';
import { createProjectSubRows } from '../helpers/createProjectSubRows';

export const usePresalesAllTableData = ({
  presalesAllRows,
}: {
  presalesAllRows: ClientProjectHours[];
  // TODO: Change the return type
}): any[] => {
  const presalesAllTableData = presalesAllRows.map((period) => {
    const customerName = period.client;

    if (period.projects?.length) {
      const filteredProjects = filterUniqueProjects(period.projects);
      const totalHours = calculateTotalHours(period.projects);
      const groupByProjectRows = groupByProjects(period.projects);
      const totalCost = Number(
        period.projects
          .reduce(
            (acc, project) => acc + Number((project.cost || 0).toFixed(2)),
            0,
          )
          .toFixed(2),
      );

      return {
        name: customerName || '',
        countHours: `Total: ${decimalToTime(totalHours)}`,
        costHours: `Total: ${decimalToTime(totalHours)}`,
        cost: {
          value: totalCost,
          formatted: `$${totalCost.toFixed(2)}`,
          color: 'green',
        },
        totalHours,
        subRows: createProjectSubRows(filteredProjects, groupByProjectRows),
      };
    }

    return null;
  });

  return presalesAllTableData;
};
